import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCy30dWPXcHGJlxI-O95-1FCjRA_3gPAfM",
  authDomain: "esg-influencer-b1ea5.firebaseapp.com",
  projectId: "esg-influencer-b1ea5",
  storageBucket: "esg-influencer-b1ea5.firebasestorage.app",
  messagingSenderId: "914822450232",
  appId: "1:914822450232:web:ac4d73d2946038227f6acd",
  measurementId: "G-7TLEPL9VNX",
  appVerificationDisabledForTesting: true,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// let auth = firebase.auth();
// export { auth, firebase };
